import React from "react";
import { Screen } from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'

const SupportScreen = () => {
  return (
    <Screen
      id='support'
      title={<span>Бесплатная <StyledScreen.GreenText>24/7</StyledScreen.GreenText> техподдержка</span>}
      subTitle='по всем каналам связи'
      bottomLine={true}
    >
      <Styled.IconsContainer>
        <Styled.Icon><img src={process.env.PUBLIC_DIR + '/images/phone-icon-large-gray.svg'} alt='phone' /></Styled.Icon>
        <Styled.Icon><img src={process.env.PUBLIC_DIR + '/images/mail-icon-large-gray.svg'} alt='phone' /></Styled.Icon>
        <Styled.Icon><img src={process.env.PUBLIC_DIR + '/images/message-icon-large-gray.svg'} alt='phone' /></Styled.Icon>
        <Styled.Icon><img src={process.env.PUBLIC_DIR + '/images/telegram-icon-large-gray.svg'} alt='phone' /></Styled.Icon>
      </Styled.IconsContainer>
    </Screen>
  )
}

export { SupportScreen }
